import { render, staticRenderFns } from "./index9.vue?vue&type=template&id=452d9608&scoped=true&"
import script from "./index9.vue?vue&type=script&lang=js&"
export * from "./index9.vue?vue&type=script&lang=js&"
import style0 from "./index9.vue?vue&type=style&index=0&id=452d9608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452d9608",
  null
  
)

export default component.exports